import { useDispatch } from "react-redux";
import { AESDecryption } from "../../utils/Aes";
import { decodeToken, isExpired } from "react-jwt";
import { loginSuccess, logout } from "../../redux/slices/authSlice";
import { Navigate } from "react-router-dom";

const RequireJWT = ({ children }) => {
    const dispatch = useDispatch();
    let isExpiredValue = false;
    const encryptedToken = localStorage.getItem('token');
    
    if(encryptedToken){
      const token = AESDecryption(encryptedToken);
      
      const DecodedToken = decodeToken(token);
      const isTokenExpired = isExpired(token);
      
      if(isTokenExpired){
        isExpiredValue = true;
        dispatch(logout());
      }else{

        const payload = {
          token : token,
          userId : DecodedToken.userId,
          firstName: DecodedToken.firstName,
          email: DecodedToken.email,
          role: DecodedToken.role
        }
        dispatch(loginSuccess(payload));
        isExpiredValue=false
       }
       return !isExpiredValue ? children : <Navigate to="/login" replace />;
    }else{
        return <Navigate to="/login" replace />;
    }
};

export default RequireJWT;
    